import { CommonModule } from '@angular/common';
import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { getSessionId, saveToStorageAsync } from '../../helpers/storageUtils';
import { CreateLead } from '../../Models/createLead';
import { DatosGenerales } from '../../Models/datosGenerales';
import { LeadResponse } from '../../Models/leadResponse';
import { leadUpdate } from '../../Models/updateLead';
import { ExceptionService } from '../../services/excepciones/exception.service';
import { LeadsService } from '../../services/Leads/leads.service';
import { TrackingService } from '../../services/tracking.service';
import { UtilsService } from '../../services/utils.service';
import { selectData } from '../../storage/Lead/data.selectors';
import { BannerAppComponent } from '../banner-app/banner-app.component';
import { AutorizationModalComponent } from '../common/autorization-modal/autorization-modal.component';
import { FooterAppComponent } from '../footer-app/footer-app.component';

@Component({
  selector: 'app-lead-errado',
  standalone: true,
  imports: [BannerAppComponent, FooterAppComponent, ReactiveFormsModule, CommonModule, NgbModule],
  templateUrl: './lead-errado.component.html',
  styleUrls: ['./lead-errado.component.scss'],
})
export class LeadErradoComponent implements OnInit {
  private trackingService = inject(TrackingService);
  router = inject(Router);
  utils = inject(UtilsService);

  @ViewChild('nombreCliente') nombreCliente2!: ElementRef;
  @ViewChild('numCelular') numCelular2!: ElementRef;
  @ViewChild('correo') correoElec2!: ElementRef;
  emailPattern = environment.PATTERN_EMAIL;
  celularPattern = environment.PATTERN_CELULAR;

  completo = '';
  leadId = '';
  sessionId = '';

  datosGenerales: DatosGenerales | null = null;
  datosGenerales$: Observable<DatosGenerales | null>;
  leadResponse: LeadResponse | null = null;
  datosLead: CreateLead = {
    plate: '',
    confirm_plate: '',
    owner_borndate: '',
    circulation_zone_id: '',
    use_type: '',
    accept_tos: false,
    name: '',
    mobile_phone: '',
    assessor_code: 0,
  };

  leadUpdate: leadUpdate = {
    firstname: '',
    phone: '',
    email: '',
    accept_tos: false,
  };

  formulario: FormGroup = new FormGroup({
    nombreCliente: new FormControl('', [Validators.required]),
    numCelular: new FormControl('', [
      Validators.minLength(6),
      Validators.maxLength(10),
      Validators.pattern(this.celularPattern),
    ]),
    correo: new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.pattern(this.emailPattern),
    ]),
    flexCheckAutoriza: new FormControl(false),
  });
  codAsesor = '';
  codePause?: number;

  constructor(
    private store: Store,
    private leadServices: LeadsService,
    private modalService: NgbModal,
    private exceptionService: ExceptionService,
  ) {
    this.datosGenerales$ = this.store.select(selectData);
  }

  ngOnInit(): void {
    this.trackingService.enviarEventoCotizacionPausa('cotizacion_pausa_estado', 'Pageview');
    this.codePause = this.trackingService.getcodePause();
    this.sessionId = getSessionId().toString();
    this.datosGenerales$.subscribe((data) => {
      this.datosGenerales = data;
    });
  }

  valNombre = false;
  valNombre2 = true;
  validacionNombre() {
    if (this.formulario.get('nombreCliente')?.value === '') {
      this.valNombre = !this.valNombre;
      this.valNombre2 = !this.valNombre2;
    } else {
      this.valNombre = false;
      this.valNombre2 = true;
    }
  }

  valCelular = false;
  valCelular2 = true;
  validacionCelular() {
    if (this.formulario.get('numCelular')?.value === '') {
      this.valCelular = !this.valCelular;
      this.valCelular2 = !this.valCelular2;
    } else {
      this.valCelular = false;
      this.valCelular2 = true;
    }
  }

  valEmail = false;
  valEmail2 = true;
  validacionEmail() {
    if (this.formulario.get('correo')?.value === '') {
      this.valEmail = !this.valEmail;
      this.valEmail2 = !this.valEmail2;
    } else {
      this.valEmail = false;
      this.valEmail2 = true;
    }
  }

  get nombreNoValido() {
    return (
      this.formulario.get('nombreCliente')?.invalid && this.formulario.get('nombreCliente')?.touched
    );
  }

  get correoNoValido() {
    return this.formulario.get('correo')?.invalid && this.formulario.get('correo')?.touched;
  }

  get cedularNoValido() {
    return this.formulario.get('numCelular')?.invalid && this.formulario.get('numCelular')?.touched;
  }

  get formularioNoValido() {
    return this.formulario.invalid;
  }

  siguientePagina() {
    if (this.datosGenerales?.LeadResponse.data.Id === undefined) {
      this.leadId = this.datosGenerales?.LeadResponse.data.lead_id || '';
    } else {
      this.leadId = this.datosGenerales?.LeadResponse.data.Id;
    }

    this.leadUpdate.lastname = this.formulario.get('nombreCliente')?.value;
    this.leadUpdate.phone = this.formulario.get('numCelular')?.value.toString();
    this.leadUpdate.email = this.formulario.get('correo')?.value.toString();
    this.leadUpdate.accept_tos = true;

    if (this.datosLead) {
      this.trackingService.enviarEventoCotizacionPausa(
        'cotizacion_pausa_estado',
        'Button',
        'Enviar',
      );
      saveToStorageAsync('ya_tenemos_tus_datos', this.codePause, 'session');
      this.leadServices.actualizarLeads(this.leadUpdate, this.sessionId, this.leadId).subscribe({
        next: (resp) => {
          this.actualizarPorcentaje();
          this.leadServices.handleSuccess(resp);
        },
        error: (error) => console.error('Error al actualizar lead:', error),
      });
    } else {
      // Handle the case where datosLead is undefined
      console.error('datosLead is undefined');
    }
  }

  actualizarPorcentaje() {
    // Se actualiza el porcentaje de la excepción
    this.exceptionService
      .addExceptionNew(this.sessionId, this.leadId, 'Datos RUNT no coinciden', 35, 'Habilitado')
      .subscribe({
        next: (resp) => {
          console.log('Se actualizo el porcentaje de la excepción');
        },
        error: (error) =>
          console.error('Error al actualizar el porcentaje de la excepción:', error),
      });
  }

  volverAlInicio() {
    this.utils.handleredirect(this.codAsesor, '/inicio');
  }

  // siguientePaginaOLD() {
  //   // this.datosLead = this.datosGenerales?.Lead;
  //   this.datosLead.assessor_code = this.datosGenerales?.Lead.assessor_code ?? 0;
  //   this.datosLead.plate = this.datosGenerales?.Lead.plate ?? '';
  //   this.datosLead.confirm_plate = this.datosGenerales?.Lead.confirm_plate ?? '';
  //   this.datosLead.owner_borndate = this.datosGenerales?.Lead.owner_borndate ?? '';
  //   this.datosLead.circulation_zone_id = this.datosGenerales?.Lead.circulation_zone_id ?? '';
  //   this.datosLead.use_type = this.datosGenerales?.Lead.use_type ?? '';
  //   this.datosLead.accept_tos = true;
  //   this.datosLead.name = this.formulario.get("nombreCliente")?.value;
  //   this.datosLead.mobile_phone = this.formulario.get("numCelular")?.value.toString();

  //   if (this.datosLead) {
  //     this.leadServices.postCrearLeads(this.datosLead, this.sessionId)
  //       .subscribe(
  //         (data) => {
  //           this.leadResponse = data;
  //           if (this.leadResponse) {
  //             this.router.navigate([FEEDBACK]);
  //           }
  //         }
  //       );
  //   } else {
  //     // Handle the case where datosLead is undefined
  //     console.error('datosLead is undefined');
  //   }
  // }

  openModal() {
    const modalRef = this.modalService.open(AutorizationModalComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.title = 'Política de privacidad y Tratamiento de datos personales';
    modalRef.componentInstance.close.subscribe(() => {
      modalRef.close();
    });
  }

  blockUnicode(event: KeyboardEvent) {
    // Bloquea ñ y Ñ
    if (event.key === 'ñ' || event.key === 'Ñ') {
      event.preventDefault();
    }
  }
}
